import Prismic from "prismic-javascript"

// Primsic token and repo name constants
const apiEndpoint = `https://${process.env.GATSBY_PRISMIC_REPO_NAME}.cdn.prismic.io/api/v2`
const accessToken = process.env.GATSBY_API_KEY

export const Client = Prismic.client(apiEndpoint, { accessToken })
